// Script to customize the Zepto personalizer plugin according to our needs

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    hideAllCheckboxes();
    wrapDropdownsAndCheckboxes();
    setDropdownsListeners();
    addDragableBehaviour();
  }, 1000);
});

function hideAllCheckboxes() {
  const checkBoxLists = document.querySelectorAll(
    ".pplr-wrapper.pplr-checkbox"
  );
  if (checkBoxLists.length === 0) return;
  checkBoxLists.forEach((checkBoxList) => {
    checkBoxList.style.display = "none";
  });
}

function setDropdownsListeners() {
  const allDropdowns = document.querySelectorAll(
    ".pplr-static-options .pplr-drop-item"
  );
  if (allDropdowns.length === 0) return;

  allDropdowns.forEach((dropdown) => {
    dropdown.addEventListener("click", () => toggleCheckboxList(dropdown));
  });
}

function toggleCheckboxList(dropdown) {
  const id = dropdown
    .getAttribute("data-value")
    .replaceAll(" ", "-")
    .toLowerCase();
  const checkBoxLists = document.querySelectorAll(
    ".pplr-wrapper.pplr-checkbox"
  );
  if (checkBoxLists.length === 0) return;

  const currentCheckbox = [...checkBoxLists].find((checkBoxList) =>
    checkBoxList.classList.contains(`pplr-${id}`)
  );
  if (!currentCheckbox) return;

  if (currentCheckbox.style.display === "none") {
    hideAllCheckboxes();
    currentCheckbox.style =
      "display: flex; opacity: 1; position: relative; pointer-events: auto;";
  } else {
    hideAllCheckboxes();
    dropdown.classList.remove("active");
  }
}

function wrapDropdownsAndCheckboxes() {
  const dropdownsContainer = document.querySelector(".pplr-static-options");
  const dropdownsContainerClone = dropdownsContainer.cloneNode(true);
  const div = document.createElement("div");
  const checkBoxLists = document.querySelectorAll(
    ".pplr-wrapper.pplr-checkbox"
  );

  const nodes = [dropdownsContainerClone, ...checkBoxLists];
  div.append(...nodes);
  div.classList.add("pplr--dropdowns-checkboxes-container");
  dropdownsContainer.replaceWith(div);
}

function addDragableBehaviour() {
  const containers = document.querySelectorAll(".pplr-wrapper.pplr-checkbox");
  if (containers.length === 0) return;

  containers.forEach((slider) => {
    if (slider !== containers[containers.length - 1]) return;

    slider.classList.add("draggable");
    let mouseDown = false;
    let startX, scrollLeft;
    let startDragging = function (e) {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    let stopDragging = function (event) {
      mouseDown = false;
    };

    slider.addEventListener("mousemove", (e) => {
      e.preventDefault();
      if (!mouseDown) {
        return;
      }
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
    });

    slider.addEventListener("mousedown", startDragging, false);
    slider.addEventListener("mouseup", stopDragging, false);
    slider.addEventListener("mouseleave", stopDragging, false);
  });
}

// In case client want back the swatches with labels
function addLabelToSwatches() {
  //   console.log("addLabelToSwatches");
  //   const parent = document.querySelector(
  //     ".pplr-swatch-main.img_thumb_small_circle"
  //   );
  //   const swatches = document.querySelectorAll(".pplr-swatch-element.pplrimage ");
  //   if (swatches.length === 0 || !parent) return;
  //   const allSwatchesWithLabels = [];
  //   swatches.forEach((swatch) => {
  //     // const block = document.createElement("div");
  //     // block.style =
  //     //   "display: flex; flex-direction: column; align-items: center; justify-content: center";
  //     // block.appendChild(swatch);
  //     const label = document.createElement("span");
  //     // swatch.style = "width: 55px; height: 55px;";
  //     label.style =
  //       "font-size: 12px; text-align: center; position: absolute; bottom: 0; left: 50%; width: 170%; height: 70px; transform: translate(-50%, 75px); line-height: 14px;";
  //     label.textContent = swatch.getAttribute("data-val");
  //     swatch.appendChild(label);
  //     allSwatchesWithLabels.push(swatch);
  //   });
  //   parent.replaceChildren(...allSwatchesWithLabels);
}
